<template>
  <div class="organize-tree">
    <loading :isShow="$root.$children[0].isShowLoading" />
    <!-- 树 -->
    <div class="searchBox">
      <Input
        v-model="searchValue"
        placeholder="输入名称搜索"
        style="width: auto"
        clearable
        @on-clear="clearInput"
        @on-enter="searchData"
        @on-change="watchInput"
        v-if="type != 'child' && !hideSearch"
      >
        <Icon type="ios-search" slot="suffix" size="20" color="#A8ADB7" />
      </Input>
    </div>
    <!-- 搜索结果 -->
    <div class="searchList" v-if="searchValue && entered">
      <div class="result" v-if="type!='select'">
        共有
        <span class="totalNum">{{ searchResult.countSum }}</span
        >条搜索结果
      </div>
      <ul class="searchResult">
        <li>
          <!-- 机构 -->
          <div
            class="item"
            v-if="searchResult && searchResult.organizations.length > 0"
          >
            <div class="bar">
              <span class="icon icon-node"></span>
              <span>机构</span>
              <span class="num"
                >({{ organizationsCopy && organizationsCopy.length }})</span
              >
            </div>
            <div
              class="list"
              v-for="(item, index) in searchResult.organizations"
              :key="index"
              @click="gotoOrg(item, searchResult.organizations)"
            >
              <div class="txtName" :class="{ active: item.active === true }">
                <Tag color="orange">{{ dealCode(item.levelCode) }}</Tag>
                <span>{{ item.name }}</span>
              </div>
              <Breadcrumb separator=">" v-if="item.nameTree.length > 0">
                <BreadcrumbItem
                  v-for="(item2, index2) in item.nameTree"
                  :key="index2"
                  >{{ item2 }}</BreadcrumbItem
                >
              </Breadcrumb>
            </div>
            <div class="line"></div>
            <div
              class="more"
              @click="toggleOrg"
              v-if="organizationsCopy.length > 3 && type!='select'"
            >
              <!-- <span>更多结果</span>
              <Icon type="ios-arrow-down" color="#727c8e" />-->
              <span>{{ isShowMore_org === true ? "查看更多" : "收起" }}</span>
              <Icon
                :type="
                  isShowMore_org === true ? 'ios-arrow-down' : 'ios-arrow-up'
                "
                color="#727c8e"
              />
            </div>
          </div>
          <!-- 团队 -->
          <!-- icon-threeP -->
          <div
            class="item"
            v-if="searchResult && searchResult.groups.length > 0"
          >
            <div class="bar">
              <span class="icon icon-threeP"></span>
              <span>团队</span>
              <span class="num">({{ groupsCopy && groupsCopy.length }})</span>
            </div>
            <div class="list">
              <div
                v-for="(item, index) in searchResult.groups"
                :key="index"
                @click="toQueneDetail(item, searchResult.groups)"
              >
                <div class="txtName" :class="{ active: item.active === true }">
                  <span>{{ item.name }}</span>
                </div>
                <Breadcrumb separator=">" v-if="item.nameTree.length > 0">
                  <BreadcrumbItem
                    v-for="(item2, index2) in item.nameTree"
                    :key="index2"
                    >{{ item2 }}</BreadcrumbItem
                  >
                </Breadcrumb>
              </div>
              <div class="line"></div>
              <div
                class="more"
                @click="toggleQuene"
                v-if="groupsCopy.length > 3"
              >
                <span>{{
                  isShowMore_quene === true ? "查看更多" : "收起"
                }}</span>
                <Icon
                  :type="
                    isShowMore_quene === true
                      ? 'ios-arrow-down'
                      : 'ios-arrow-up'
                  "
                  color="#727c8e"
                />
              </div>
            </div>
          </div>
          <!-- 业务员 -->
          <div
            class="item"
            v-if="
              searchResult.userBasePage &&
              searchResult.userBasePage.records.length > 0
            "
          >
            <div class="bar">
              <span class="icon icon-per"></span>
              <span>业务员</span>
              <span class="num">({{ searchResult.userBasePage.total }})</span>
            </div>
            <div class="list">
              <div
                @click="toServerDetail(item, searchResult.userBasePage.records)"
                v-for="(item, index) in searchResult.userBasePage.records"
                :key="index"
              >
                <div class="txtName" :class="{ active: item.active === true }">
                  <span>{{ item.name }}</span>
                </div>
                <Breadcrumb separator=">" v-if="item.nameTree.length > 0">
                  <BreadcrumbItem
                    v-for="(item2, index2) in item.nameTree"
                    :key="index2"
                    >{{ item2 }}</BreadcrumbItem
                  >
                </Breadcrumb>
              </div>
              <div class="line"></div>
              <div
                class="more"
                @click="toNext"
                v-if="searchResult.userBasePage.records.length < total"
              >
                <span>更多结果</span>
                <Icon type="ios-arrow-down" color="#727c8e" />
              </div>
            </div>
          </div>
          <!-- icon-per -->
        </li>
      </ul>
    </div>
    <Tree
      v-else
      :data="treeData"
      :render="renderTree"
      @on-select-change="selectNode"
    ></Tree>
  </div>
</template>
<script>
import {
  getOrganizationInfo,
  organizationBaseSearchByMobile,
} from "@/api/httpList";
export default {
  props: {
    type: null,
    typeTree: null,
    hideSearch: null,
    isAll: false,
    expandAll: Boolean,
    disabledInit: Boolean,
    getInfo: Boolean,
  },
  data() {
    return {
      groupsCopy: [], //团队备份
      organizationsCopy: [], //机构备份
      queneHeight: "auto",
      toggleHeight_server: "auto",
      isShowMore_org: false, //机构查看更多  true需要折叠 false展开
      isShowMore_quene: false, //团队查看更多 true需要折叠 false展开
      showMore_org: false,
      showMore_quene: false,
      showMore_server: false, //显示业务员
      total: 0, //业务员总页数
      pageNo: 1, //当前页
      pageSize: 3, //
      entered: false, //用户是否回车搜索
      minHeight: "",
      searchResult: "", //搜索结果
      searchValue: "",
      treeData: [],
    };
  },
  watch: {
    isShowMore_org(newVal) {
      if (newVal) {
        this.searchResult.organizations = this.searchResult.organizations.slice(
          0,
          3
        );
      } else {
        this.searchResult.organizations = JSON.parse(
          JSON.stringify(this.organizationsCopy)
        );
      }
    },
    isShowMore_quene(newVal) {
      if (newVal) {
        this.searchResult.groups = this.searchResult.groups.slice(0, 3);
      } else {
        this.searchResult.groups = JSON.parse(JSON.stringify(this.groupsCopy));
      }
    },
  },
  mounted() {
    if (this.type == "select" || this.type == "selectChild" || this.disabledInit) {
      return;
    }
    this.init();
  },
  methods: {
    //输入框清除
    clearInput() {
      this.$emit("clearInput");
    },
    clearValue() {
      this.searchValue = "";
    },
    init() {
      if (this.treeData.length) {
        return;
      }
      this.getTree();
      this.$nextTick(() => {
        if (document.querySelector(".titleBox")) {
          this.minHeight =
            document.body.offsetHeight -
            document.querySelector(".titleBox").offsetHeight;
        }
      });
      window.onresize = () => {
        if (document.querySelector(".titleBox")) {
          this.minHeight =
            document.body.offsetHeight -
            document.querySelector(".titleBox").offsetHeight;
        }
      };
    },
    //根据组织id请求数据
    selectNode(nodeArr, cur) {
      const vm = this;
      const id = cur.id;
      if (id === this.$store.state.currentTreeId) return; //防止重复点击
      //根据id请求数据
      this.curTreeId = id;
      if (this.type == "select" || this.type == "selectChild") {
        this.$emit("selectNode", nodeArr, cur);
        return;
      }
      //更新面包屑
      this.navList = this.familyTree(nodeArr, this.curTreeId); //面包屑

      if (cur.nodeType === 1) {
        //1 机构
        this.$root.$children[0].isShowLoading = true;
        this.$store.commit("setMechNavList", {
          id: this.curTreeId,
        });
        this.$store.dispatch("setMechOranization", {
          id,
          callback() {
            vm.$root.$children[0].isShowLoading = false;
            console.log(vm.$store.state.mechNavList);
            vm.$emit("selectNode", nodeArr, cur);
          },
        });
      } else if (cur.nodeType === 2) {
        //2团队
        this.$store.commit("setMechNavList", {
          id: this.curTreeId,
        });
        this.$emit("selectNode", nodeArr, cur);
      }
    },
    familyTree(arr1, id) {
      let temp = [];
      let forFn = function (arr, id) {
        for (let i = 0; i < arr.length; i++) {
          let item = arr[i];
          if (item.id === id) {
            temp.push(item);
            forFn(arr1, item.parentId);
            break;
          } else {
            if (item.children && item.children.length > 0) {
              forFn(item.children, id);
            }
          }
        }
      };
      forFn(arr1, id);
      return temp.reverse();
    },
    /***自定义树渲染相关***/
    renderIcon(root, data) {
      const icon = (
        <span class="icon icon-tree_per" style="margin-right:2px"></span>
      );
      if (data.nodeType == 2) {
        return icon;
      }
    },
    renderTree(h, { root, node, data }) {
      if (data.disabled) {
        return (
          <div class="tree-disabled">
            <span>{this.renderIcon(root, data)}</span>
            <span>{data.title}</span>
          </div>
        );
      } else {
        return (
          <div>
            <span>{this.renderIcon(root, data)}</span>
            <span>{data.title}</span>
          </div>
        );
      }
    },
    /***自定义树渲染相关***/
    //去机构页
    gotoOrg(item, arr) {
      this.searchResult.organizations.forEach((item) => {
        this.$set(item, "active", false);
      });
      this.searchResult.groups.forEach((item) => {
        this.$set(item, "active", false);
      });
      this.searchResult.userBasePage.records.forEach((item) => {
        this.$set(item, "active", false);
      });

      item.active = true;
      this.$store.commit("setMechNavList", {
        id: item.id,
      });
      this.$store.dispatch("setMechOranization", {
        id: item.id,
      });
      // select类型不跳转
      if(this.type == "select"){

        return;
      }
      this.$router.push({
        name: "oranized",
        query: { id: item.id },
      });
    },
    toQueneDetail(item, arr) {
      this.searchResult.organizations.forEach((item) => {
        this.$set(item, "active", false);
      });
      this.searchResult.groups.forEach((item) => {
        this.$set(item, "active", false);
      });
      this.searchResult.userBasePage.records.forEach((item) => {
        this.$set(item, "active", false);
      });
      item.active = true;
      this.$store.commit("setMechNavList", {
        id: item.id,
      });
      this.$router.push({
        name: "mechOranizationDetail",
        query: { id: item.id },
      });
    },
    toServerDetail(item, arr) {
      this.searchResult.organizations.forEach((item) => {
        this.$set(item, "active", false);
      });
      this.searchResult.groups.forEach((item) => {
        this.$set(item, "active", false);
      });
      this.searchResult.userBasePage.records.forEach((item) => {
        this.$set(item, "active", false);
      });
      item.active = true;
      this.$store.commit("setMechNavList", {
        id: item.id,
      });
      this.$router.push({
        name: "mechOranizationServerDetail",
        params: { id: item.id },
      });
    },
    dealCode(code) {
      const num = +code;
      switch (num) {
        case 10001:
          return "总部";
        case 10002:
          return "一级";
        case 10003:
          return "二级";
        case 10004:
          return "三级";
        case 10005:
          return "四级";
      }
    },
    dealTree(arr) {
      return arr.map((item) => ({
        ...item,
        expand: this.expandAll ? true : item.parentId === "0" ? true : false,
        // expand: true,
        title: item.name,
        selected: false,
        children:
          item.children && item.children.length > 0
            ? this.dealTree(item.children)
            : null,
      }));
    },
    //根据手机号搜索
    searchData() {
      this.entered = true;
      if (this.searchValue) {
      }
      this.pageNo = 1;
      organizationBaseSearchByMobile({
        keywords: this.searchValue,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      }).then((res) => {
        this.isShowMore_org = false;
        this.isShowMore_quene = false;
        this.showMore_server = false;
        this.$nextTick(() => {
          this.searchResult = res.data;
          this.organizationsCopy = res.data.organizations;
          this.groupsCopy = res.data.groups;
          this.total = res.data.userBasePage.total;
          if (this.organizationsCopy.length > 3) this.isShowMore_org = true;
          if (this.groupsCopy.length > 3) this.isShowMore_quene = true;
          if (this.total >= 3) this.showMore_server = true;
          // select模式仅显示机构
          if(this.type == "select"){
            this.searchResult.groups = [];
            this.searchResult.userBasePage = {
              records:[]
            };
            this.isShowMore_org = false;
          }
        });
      });
    },
    //查询业务员下一页
    toNext() {
      if (this.total > 0 && this.pageNo < this.total) {
        this.pageNo++;
        organizationBaseSearchByMobile({
          keywords: this.searchValue,
          pageNo: this.pageNo,
          pageSize: this.pageSize,
        }).then((res) => {
          this.searchResult.userBasePage.records.push(
            ...res.data.userBasePage.records
          );
        });
      } else {
        //加载完
        this.showMore_server = false;
      }
    },
    //切换团队查看更多
    toggleQuene() {
      this.isShowMore_quene = !this.isShowMore_quene;
    },
    //机构查看更多
    toggleOrg() {
      this.isShowMore_org = !this.isShowMore_org;
    },
    //监听输入
    watchInput() {
      if (!this.searchValue) {
        this.entered = false;
      }
    },
    //获取组织树形结构
    getTree(isLoad, curObj) {
      this.$http({
        type: 'POST',
        url: '/buz/organizationBase/read/tree',
        data: {
          source:2,
        },
      }).then((res) => {
        this.$root.$children[0].isShowLoading = false;
        this.treeData = this.dealTree([res.data]); //树数据
        let selecteItem = curObj ? curObj : this.treeData[0];
        this.$store.commit("setMechNavList", {
          mechTreeList: this.treeData,
        });
        if (this.type == "select") {
          this.$root.$children[0].isShowLoading = false;
          return;
        } else if (this.type == "selectChild") {
          if (!this.isAll) {
            selecteItem.disabled = true;
          }
          this.$root.$children[0].isShowLoading = false;
          return;
        } else if (this.type == "child") {
          selecteItem.disabled = true;
          if (
            !this.treeData[0].children ||
            this.treeData[0].children.length == 0
          ) {
            this.$emit("selectNode", this.treeData, {}, isLoad);
            this.$root.$children[0].isShowLoading = false;
            return;
          }
          selecteItem = this.treeData[0].children[0];
          this.curTreeId = selecteItem.id;
          this.$store.commit("setMechNavList", {
            id: this.curTreeId,
          });
          this.$emit("selectNode", this.treeData, selecteItem, isLoad);
          this.$root.$children[0].isShowLoading = false;
        } else {
          this.curTreeId = selecteItem.id;
          this.$store.commit("setMechNavList", {
            id: this.curTreeId,
          });
          this.$emit("selectNode", this.treeData, selecteItem, isLoad);
        }
        this.$store.commit("setRequestId", this.curTreeId);
        if (selecteItem.nodeType != 1) {
          return;
        }
        if (!this.getInfo) {
          return;
        }
        getOrganizationInfo({ organizationId: this.curTreeId })
          .then((res) => {
            this.$root.$children[0].isShowLoading = false;
            this.$store.commit("setMechOranization", res.data);
          })
          .catch((err) => {
            console.log(err);
            this.$root.$children[0].isShowLoading = false;
          });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./organizeTree.scss";
</style>
